import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MetaPixelTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Check if fbq is defined (it should be from the script in index.html)
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }
    }, [location]);

    return null;
};

export default MetaPixelTracker;
